import { API_CONFIG } from './config.js';

export class ApiError extends Error {
  constructor(message, status, details) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.details = details;
  }
}

async function withTimeout(promise, ms) {
  let timer;
  const timeout = new Promise((_, rej) => {
    timer = setTimeout(() => rej(new ApiError('Request timed out', 408)), ms);
  });
  try { return await Promise.race([promise, timeout]); }
  finally { clearTimeout(timer); }
}

export async function request(path, { method = 'GET', body, headers = {}, signal } = {}) {
  const url = path.startsWith('http') ? path : `${API_CONFIG.baseUrl}${path}`;
  const init = {
    method,
    signal,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ...headers,
    },
  };
  if (body !== undefined) init.body = JSON.stringify(body);

  const res = await withTimeout(fetch(url, init), API_CONFIG.timeoutMs);

  const isJson = (res.headers.get('content-type') || '').includes('application/json');
  const payload = isJson ? await res.json().catch(() => null) : await res.text();

  if (!res.ok) {
    const msg = (payload && payload.message) || `Request failed (${res.status})`;
    throw new ApiError(msg, res.status, payload);
  }
  return payload;
}

export const api = {
  get:    (p, opts) => request(p, { ...opts, method: 'GET' }),
  post:   (p, b, opts) => request(p, { ...opts, method: 'POST', body: b }),
  put:    (p, b, opts) => request(p, { ...opts, method: 'PUT', body: b }),
  patch:  (p, b, opts) => request(p, { ...opts, method: 'PATCH', body: b }),
  delete: (p, opts) => request(p, { ...opts, method: 'DELETE' }),
};